import HttpClient, { type HttpRequestConfig } from '../HttpClient';
import HTTPResponse from '../HttpResponse';
import { type UserState } from '../../reducers/user/userTypes';

interface UserResponseData {
  firstName?: string;
  firstNamePhonetic?: string;
  lastName?: string;
  lastNamePhonetic?: string;
  states?: string;
  city?: string;
  streetAddress?: string;
  streetAddress2?: string;
  streetAddress3?: string;
  postalCode?: string;
  companyName?: string;
  email?: string;
  phoneNumber?: string;
  countryCode?: string;
  languageCode?: string;
  customerNumber?: string;
  type: 'Individual' | 'Business';
  allowedDiscounts?: boolean;
  integrityConsentMap?: {
    AcceptPrivacyPolicy?: boolean;
    AllowPersonalEmail?: boolean;
    AllowSalesProfileSharing?: boolean;
  };
}

const mapUser = (userResponseData: UserResponseData): UserState => {
  return {
    isLoggedIn: true,
    privacyPolicy: true,
    firstName: userResponseData.firstName,
    firstNamePhonetic: userResponseData.firstNamePhonetic,
    lastName: userResponseData.lastName,
    lastNamePhonetic: userResponseData.lastNamePhonetic,
    state: userResponseData.states,
    city: userResponseData.city || '',
    streetAddress: userResponseData.streetAddress || '',
    streetAddress2: userResponseData.streetAddress2,
    postCode: userResponseData.postalCode || '',
    businessName: userResponseData.companyName,
    email: userResponseData.email,
    phoneNumber: userResponseData.phoneNumber,
    country: userResponseData.countryCode || '',
    customerNumber: userResponseData.customerNumber,
    customerType: userResponseData.type,
    allowedMemberDiscounts:
      userResponseData.allowedDiscounts ||
      userResponseData.type === 'Individual',
    allowPersonalEmail:
      userResponseData.integrityConsentMap?.AllowPersonalEmail,
  };
};

class UserService {
  private httpBokaCustomer: HttpClient;

  public constructor(httpBokaCustomer: HttpClient) {
    this.httpBokaCustomer = httpBokaCustomer;
  }

  public async getUserInformation(
    config: HttpRequestConfig,
  ): Promise<HTTPResponse<UserState | null>> {
    const response = await this.httpBokaCustomer.get<UserResponseData>(
      'customer',
      config,
    );
    const user = mapUser(response.data);
    return new HTTPResponse(user);
  }
}

export default UserService;
